import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GalleryLayout13 } from '@components/gallery/components/gallery-layout-13/model';
import { ResponsiveService } from '@services/responsive';
import { ImageComponent } from '@shared/components/image';
import { VideoComponent } from '@shared/components/video';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-gallery-layout-13',
  imports: [ImageComponent, VideoComponent],
  templateUrl: './gallery-layout-13.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryLayout13Component {
  readonly data = input.required<GalleryLayout13>();

  desktopHeight = signal(900);
  mobileHeight = signal(234);
  imageLoaded = signal(false);
  readonly #responsiveService = inject(ResponsiveService);

  constructor() {
    this.#responsiveService
      .getWidth$()
      .pipe(
        takeUntilDestroyed(),
        tap((width) => {
          const data = this.data();
          if (data?.keepImageSize && data.image) {
            this.desktopHeight.set(Math.round((data.image.gravity.height * width) / data.image.gravity.width));
            this.mobileHeight.set(Math.round((data.image.gravity.height * width) / data.image.gravity.width));
          }
          this.imageLoaded.set(true);
        })
      )
      .subscribe();
  }
}
